function NotFound(){
    return <h1>Not Found Sorry :(</h1>
}

export default NotFound;